import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {ReportsRoutingModule} from "./reports-routing.module";
import {ReportsComponent} from "./reports.component";
import {DeliveryModule} from "../delivery/delivery.module";
import {DataTableModule} from "../reusable-components/data-table/data-table.module";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatSelectModule} from "@angular/material/select";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {ReactiveFormsModule} from "@angular/forms";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";

@NgModule({
  declarations: [ReportsComponent],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    DeliveryModule,
    DataTableModule,
    MatSlideToggleModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class ReportsModule {}
